import $ from 'jquery';

export default function showHideLunch () {
	var $lunch = $('#lunch');
	var $museum = $('#cfMuseum');
	if($museum.val() == 'm-shed' || $museum.val() == 'bristol-museum-and-art-gallery'){
		$lunch.show();
	} else {
		$lunch.hide();
	}
	$museum.on('change', function(e) {
		e.preventDefault();
		if($museum.val() == 'm-shed' || $museum.val() == 'bristol-museum-and-art-gallery' || $museum.val() == ''){
			$lunch.show();
		} else {
			$lunch.hide();
		}
	});
}